import { render, staticRenderFns } from "./QueueAlert.vue?vue&type=template&id=4cfb7bc0&"
import script from "./QueueAlert.vue?vue&type=script&lang=js&"
export * from "./QueueAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports